import PropTypes from 'prop-types';
import React from 'react';

const Inspirations = ({ inspirations }) => {
  return (
    <div className="container">
      <h3>Inspirations & Advice</h3>
      <ul className="inspirations-container">
        {inspirations.map((item) => (
          <a href={item.url} key={item.id}>
            {item.displayName}
          </a>
        ))}
      </ul>

      <style jsx>{`
        .container {
          text-align: center;
        }
        .container h3 {
          font-size: 20px;
        }
        .inspirations-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          padding: 10px;
        }
        .inspirations-container a {
          color: #5a266a;
          display: block;
          font-weight: bold;
          padding: 10px;
          text-align: center;
          text-decoration: none;
          width: 33%;
        }
        .inspirations-container a:hover {
          color: #333;
        }
      `}</style>
    </div>
  );
};

export default Inspirations;

Inspirations.propTypes = {
  inspirations: PropTypes.array,
};
